import { FormEvents, FormElements, FormEventHandler } from "../../form/events/form_event_handler";

import { dataStoreRouteLoader } from "../../datastore/datastore_route_loader";

import { formatDateToBasic } from 'utils/date_utils_new.js';

export default class GridFormValuesLoader {

	static load(gridFormDataStoreRoute, gridFormName) {
		return new Promise((resolve, reject) => {
			dataStoreRouteLoader.load(gridFormDataStoreRoute).then(
				this.handleLoadSuccess.bind(this, gridFormName, resolve),
				this.handleLoadError.bind(this, gridFormName, reject)
			);
		});
	}

	static handleLoadSuccess(gridFormName, resolve, dataStoreResponse) {
		FormEventHandler.publish(FormEvents.GRID_DATA_LOAD_SUCCESS, FormElements.GRID, gridFormName, dataStoreResponse);

		if(Array.isArray(dataStoreResponse.resources))
			dataStoreResponse.resources = this.parseResponseResources(dataStoreResponse);

		resolve(dataStoreResponse);
	}

	static handleLoadError(gridFormName, reject, reason) {
		FormEventHandler.publish(FormEvents.GRID_DATA_LOAD_ERROR, FormElements.GRID, gridFormName, reason);
		reject(reason);
	}

	static parseResponseResources(dataStoreResponse) {
		return dataStoreResponse.resources.map((resource) => {
			for (const key in resource.values) {
				if (typeof resource.values[key] === 'string')
					resource.values[key] = formatDateToBasic(resource.values[key]) || resource.values[key];
			}

			const parsedResource = Object.assign({}, resource.values);
			parsedResource.id = resource.id;

			return parsedResource;
		});
	}
}
